import aceRequest from '../ace-request';

/**
 * Communication handler for the Permission service.
 */

(() => {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Creates a new PermissionService object.
   *
   * Returns a new PermissionService object.
   *
   * @param {string} permissionServiceUrl An URL to an ace user data service
   */
  atex.aceui.service.PermissionService = (permissionServiceUrl, { adaptedAxios }) => {

    const getAuth = ({ username, token }) => {
      return aceRequest ({
        token,
        url: `${permissionServiceUrl}/${username}`
      }, adaptedAxios)
        .then((response) => {
          return response.body;
        })
        .catch((error) => {
          console.error(error);
          let e = atex.aceui.HTTPUtils.createError(error, 'atex.aceui.service.PermissionService', {
            400: `Bad request when getting authorization info for "${username}"`,
            401: `Could not authenticate user while getting authorization info for "${username}"`,
            403: `Permission denied when getting authorization info for "${username}"`,
            404: `No authorization info for "${username}" was found (404)`,
            'default': `There was an error while getting authorization info for "${username}"`
          });

          e.rootCause = error.rootCause;
          throw e;
        });
    };

    return {
      /**
       * Fetches full authorization information for a given user.
       *
       * Note: Information can only be requested for the logged in user.
       *
       * Expects as input a transferInfo object:
       * {
       *   username: <string>,
       *   token: <TOKEN>
       * }
       *
       * Returns a promise that resolves to an AuthorizationInfo object:
       *
       * {
       *   contexts: {
       *     <SECURITY CONTEXT>: [ <ROLE>, ... ],
       *     ...
       *   },
       *
       *   roles: {
       *     <ROLE>: {
       *       <TYPE>: [ <PERMISSION>, ... ],
       *       ...
       *     }
       *   }
       * }
       *
       * @param {object} transferInfo
       * @param {string} transferInfo.username The subject of the authorization info
       * @param {string} transferInfo.token A security token
       */
      getAuthorizationInfo: ({ username, token }) => {
        return getAuth ({ username, token });
      },
      isSuperuser: ({ username, token }) => {
        return getAuth ({ username, token })
          .then ((authInfo) => {
            return Object.keys (authInfo.roles).includes ('sysadmin');
          });
      }
    };
  };
})();
